// LocationScreen.tsx
import { useEffect, useState, useMemo, useCallback } from 'react'
import { Breadcrumb, Button, Card, Col, Divider, Input, Pagination, Row, Select, Table, Typography } from 'antd'
import {
   HomeOutlined,
   PlusCircleOutlined,
   InfoCircleOutlined,
   EditOutlined,
   DeleteOutlined,
   ExclamationCircleOutlined,
   SearchOutlined
} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { ROUTER_PATH } from '../routes/metaData'
import useModal from 'src/helpers/modal/useModal'
import { formatCurrency } from 'src/helpers/functions'
import {
   DATE_TIME_FORMAT_BACKEND,
   DATE_TIME_FORMAT_CLIENT,
   getPage,
   PAGE_SIZE,
   TYPE_PROMOTION_CODE
} from 'src/helpers/constants'
import { isEmpty, size, trim } from 'lodash'
import { useLoading } from 'src/common/components/LoadingContainer'
import { useStore } from 'src/hooks'
import moment from 'moment'
const { Title } = Typography

const LocationScreen = observer(() => {
   const history = useHistory()
   const { t } = useTranslation()
   const { confirm } = useModal()
   const UserStore = useStore('UserStore')
   const [textSearch, set_textSearch] = useState('')
   const { showLoading, hideLoading } = useLoading()
   const [fieldFilter, setFieldFilter] = useState<any>({})

   useEffect(() => {
      getListFilterProvince()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const getListFilterProvince = async () => {
      await UserStore.getProvince({})
   }

   useEffect(() => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ q: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, fieldFilter])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         showLoading()
         // const offset = getPage(currentPage)
         const params = {
            // offset,
            ...param
         }
         console.log('param12123s', params, 'currentPage', currentPage)

         await UserStore.getLocation(params)
      } catch (error) {
         // console.log(error)
      } finally {
         hideLoading()
      }
   }

   const onChange = (currentPage: number) => {
      if (size(trim(textSearch)) > 0) {
         getListData(currentPage - 1, { ...fieldFilter, ...{ q: trim(textSearch) } })
      } else {
         getListData(currentPage - 1, { ...fieldFilter })
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }
   const handleRedirectToCreate = useCallback(() => {
      history.push(`/${ROUTER_PATH.LocationCreateScreen}`)
   }, [history])

   const showDetail = useCallback(
      (detail: any) => {
         history.push(`/${ROUTER_PATH.LocationDetailScreen.replace(':id', detail?.id?.toString())}`)
      },
      [history]
   )

   const showEdit = useCallback(
      (detail: any) => {
         UserStore.setLocationSelected(detail)
         history.push(`/${ROUTER_PATH.LocationUpdateScreen.replace(':id', detail?.id?.toString())}`)
      },
      [history]
   )

   const handleDelete = useCallback(
      (value: any) => {
         confirm({
            title: t('delete_confirm', { name: value?.name || '', code: value?.code || '' }),
            icon: <ExclamationCircleOutlined />,
            okText: t('agree'),
            cancelText: t('cancel'),
            async onOk() {
               await UserStore.deleteLocation(value?.id)
               if (size(trim(textSearch)) > 0) {
                  getListData(0, { ...fieldFilter, ...{ q: trim(textSearch) } })
               } else {
                  getListData(0, { ...fieldFilter })
               }
            }
         })
      },
      [confirm, t]
   )

   const columns = useMemo(
      () => [
         { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
         {
            title: 'Tỉnh/Thành phố',
            dataIndex: 'province',
            key: 'province',
            render: (val: any) => `${val?.name} (${val?.code})`
         },
         { title: 'Code', dataIndex: 'code', key: 'code' },
         { title: 'Tên địa điểm', dataIndex: 'name', key: 'name' },
         {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (val: any) => moment(val).format(DATE_TIME_FORMAT_CLIENT)
         },
         {
            title: t('actions'),
            key: 'action',
            align: 'center' as 'center',
            width: 120,
            fixed: 'right' as 'right',
            render: (record: any) => (
               <span>
                  {/* <span onClick={() => showDetail(record)} className="gx-link">
                     <InfoCircleOutlined />
                  </span>
                  <Divider type="vertical" /> */}
                  <span onClick={() => showEdit(record)} className="gx-link">
                     <EditOutlined />
                  </span>
                  <Divider type="vertical" />
                  <span onClick={() => handleDelete(record)} className="gx-link">
                     <DeleteOutlined />
                  </span>
               </span>
            )
         }
      ],
      [t, showDetail, showEdit, handleDelete]
   )
   // const renderPagination = () => {
   //    if (isEmpty(rows)) {
   //       return null
   //    }

   //    return (
   //       <div className="containerPagination">
   //          <Pagination
   //             onChange={onChange}
   //             pageSize={PAGE_SIZE}
   //             current={offset / PAGE_SIZE + 1}
   //             showSizeChanger={false}
   //             total={count}
   //          />
   //       </div>
   //    )
   // }
   const handleChangeRole = (value: any) => {
      if (value == fieldFilter.role || !value) {
         let x = { ...fieldFilter }
         delete x['provinceId']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ provinceId: value } })
      }
   }

   return (
      <div>
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Địa điểm'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{'Địa điểm'}</Breadcrumb.Item>
               </Breadcrumb>
            </Col>
            <Col>
               <Button icon={<PlusCircleOutlined />} type="primary" onClick={handleRedirectToCreate}>
                  {t('add_new')}
               </Button>
            </Col>
         </Row>

         <Card style={{ marginTop: '20px' }}>
            <Row gutter={16}>
               <Col span={8}>
                  <Input.Search placeholder={t('search')} allowClear onSearch={handleChangeTextSearch} />
               </Col>
               <Col span={8}>
                  <Select
                     placeholder={'Tất cả tỉnh thành'}
                     style={{ width: '100%' }}
                     allowClear
                     onChange={handleChangeRole}
                  >
                     {UserStore.listProvince?.map((item: any, index: number) => (
                        <Select.Option value={item?.id} key={index}>
                           {item?.name}
                        </Select.Option>
                     ))}
                  </Select>
               </Col>
               <Col span={4}>
                  <Button icon={<SearchOutlined />} type="primary">
                     {t('search')}
                  </Button>
               </Col>
            </Row>

            <Table
               style={{ marginTop: 20 }}
               columns={columns}
               dataSource={UserStore.listLocation || []}
               rowKey="id"
               pagination={false}
            />
            {/* {renderPagination()} */}
         </Card>
      </div>
   )
})

export default LocationScreen
